// extracted by mini-css-extract-plugin
module.exports = {"centered":"ifSHHe-kV_m6OeVocfIbx"};